import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ClientCoreModule, ClientEnvironment, ENVIRONMENT, FormArrayMapping, TableColumn } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';
import { KeyValueUtilPipe } from '../keyvalue-util.pipe';

@Component({
  selector: 'thehubz-buyout-rights-custom',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, KeyValueUtilPipe, ClientCoreModule],
  templateUrl: './buyout-rights-custom.component.html',
  styleUrl: './buyout-rights-custom.component.scss',
})
export class BuyoutRightsCustomComponent {
  @Input({ required: true }) formValue: AnyType;
  @Input({ required: true }) buyoutRightsConfigs: AnyType = [];
  @Input({ required: true }) columns: TableColumn[] = [];
  @Input() dateMultiEditText!: FormArrayMapping;
  @Input() notesColumnName = '';

  brandingKey!: CustomClients;

  constructor(@Inject(ENVIRONMENT) env: ClientEnvironment) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }
}
